import { DateTime } from "luxon";

export function getMaxInclusiveDaysAcrossYearsOfRange(
  from: Date,
  to: Date,
): number {
  return Math.max(
    DateTime.local(from.getFullYear(), 1, 1).daysInYear,
    DateTime.local(to.getFullYear(), 1, 1).daysInYear,
  );
}

export const getFirstDayOfWeek = (date: Date, firstDayOfWeek = 1) => {
  const firstDayOfWeekDate = new Date(date);
  firstDayOfWeekDate.setDate(
    firstDayOfWeekDate.getDate() - firstDayOfWeekDate.getDay() + firstDayOfWeek,
  );
  return firstDayOfWeekDate;
};

export const getFirstDayOfMonth = (date: Date) => {
  const firstDayOfMonthDate = new Date(date);
  firstDayOfMonthDate.setDate(1);
  return firstDayOfMonthDate;
};

/**
 * Generates today's date in ISO format (YYYY-MM-DD)
 * This function can be easily mocked in tests
 */
export const getTodayISOString = (): string => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

/**
 * Returns an array of DateTime objects, one for the first day of each month.
 */
export const getMonthsInRange = (
  startDate: string | Date,
  endDate: string | Date,
): DateTime[] => {
  const fromDate =
    typeof startDate === "string"
      ? DateTime.fromISO(startDate)
      : DateTime.fromJSDate(startDate);
  const toDate =
    typeof endDate === "string"
      ? DateTime.fromISO(endDate)
      : DateTime.fromJSDate(endDate);

  const months: DateTime[] = [];
  let current = fromDate.startOf("month");
  const end = toDate.endOf("month");

  while (current <= end) {
    months.push(current);
    current = current.plus({ months: 1 });
  }

  return months;
};
